"use strict";

exports.__esModule = true;
exports["default"] = SocialGoogle;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SocialGoogle(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M264 167.2c4.7 35.9-13.7 64.7-41.1 63.8s-53.8-30.7-58.6-67c-4.7-35.9 13.7-63.8 41.1-62.8 27.9.9 53.9 29.7 58.6 66zm-44.9 133.7c-41.1 0-77.5 25-77.5 55.7 0 31.1 29.3 57.1 70.4 57.1 57.6 0 77.4-24.6 77.4-55.7 0-3.8-.5-7.1-.9-10.9-4.7-17.5-20.8-26.4-43-42-7.9-2.3-16.9-3.7-26.4-4.2zM511 26.5v459c0 14.1-11.4 25.5-25.5 25.5h-459C12.4 511 1 499.6 1 485.5v-459C1 12.4 12.4 1 26.5 1h459C499.6 1 511 12.4 511 26.5zm-243.2 77h34L325.9 86H219.2c-48.2 0-93 36.3-93 78.4 0 43 32.6 77.4 81.2 77.4 3.3 0 6.6 0 9.9-.5-3.3 6.1-5.2 13.2-5.2 20.3 0 11.8 6.1 21.3 14.2 29.3h-18.4c-59 0-104.8 37.8-104.8 77 0 38.7 50.1 62.8 109.1 62.8 68 0 105.3-38.2 105.3-77 0-30.7-9.4-49.1-37.3-69.4-9.9-6.6-28.3-23.1-28.3-33.1 0-11.3 3.3-17 20.3-30.7 17.9-13.7 30.2-33.1 30.2-55.7-.1-26.9-11.9-52.8-34.6-61.3zm166.7 127h-38.2v-38.2h-25.5v38.2h-38.2V256h38.2v38.2h25.5V256h38.2v-25.5z",
    fill: "#939496"
  }));
}